var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"mr-1",attrs:{"size":"16","color":_setup.status.color}},[_vm._v(_vm._s(_setup.status.icon))]),_c('span',{staticClass:"grey--text"},[_vm._v(_vm._s(_setup.status.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }